"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PMCConfigSchema = exports.PMCV8SearchWidgetConfigSchema = exports.PMCSummaryDataFieldsSchema = exports.PMCV8SearchWidgetTypeaheadCategorySchema = exports.PMCLogoSchema = exports.PMCLogoSectionsSchema = exports.PMCSlotStatusesSchema = exports.MlocSchema = exports.MlocPeriodsSchema = exports.summaryFieldSchema = exports.PMCV8SearchWidgetValidTemplateNamesSchema = exports.PMCV8SearchWidgetValidTemplateNamesTypeSchema = exports.PMCV8SearchWidgetValidTypeaheadCategoriesSchema = exports.PMCV8SearchWidgetValidTypeaheadCategoriesTypeSchema = exports.PMCProviderConfigSchema = exports.PMCModalDisplaySchema = exports.PMCLogoMapEntrySchema = exports.PMCFacetsSchema = exports.PMCCustomVersionsSchema = exports.PMCBadgeSchema = exports.providerTileConfigSchema = exports.providerCardTabsConfigSchema = exports.baseTabSchema = exports.BASE_TABSchema = exports.crmConfigSchema = void 0;
// Generated by ts-to-zod
const zod_1 = require("zod");
const ui_theme_1 = __importStar(require("@kyruus/ui-theme"));
const types_1 = require("./types");
const extract_1 = require("../util/extract");
exports.crmConfigSchema = zod_1.z
    .object({
    enableBook: zod_1.z.boolean().optional(),
    enableRefer: zod_1.z.boolean().optional(),
    is_enabled: zod_1.z.boolean().optional(),
    maxReferralCount: zod_1.z.number().optional(),
    postMessageUrl: zod_1.z.string().optional(),
    type: zod_1.z.union([zod_1.z.literal('dynamics'), zod_1.z.literal('salesforce')]).optional()
})
    .passthrough();
exports.BASE_TABSchema = zod_1.z.nativeEnum(types_1.BASE_TAB);
exports.baseTabSchema = zod_1.z.union([
    zod_1.z.literal('locations'),
    zod_1.z.literal('notes'),
    zod_1.z.literal('insurance'),
    zod_1.z.literal('practiceGroups'),
    zod_1.z.literal('clinicalKeywords'),
    zod_1.z.literal('training'),
    zod_1.z.literal('schedulingInstructions')
]);
exports.providerCardTabsConfigSchema = zod_1.z
    .object({
    is_enabled: zod_1.z.boolean().optional(),
    tabs: zod_1.z.array(exports.baseTabSchema).optional()
})
    .passthrough();
exports.providerTileConfigSchema = zod_1.z
    .object({
    provider_card_tabs: exports.providerCardTabsConfigSchema
})
    .passthrough()
    .optional();
exports.PMCBadgeSchema = zod_1.z
    .object({
    field: zod_1.z.string()
})
    .passthrough();
exports.PMCCustomVersionsSchema = zod_1.z
    .object({
    favicon: zod_1.z.string().optional(),
    fonts: zod_1.z.string().optional(),
    footer: zod_1.z.string().optional(),
    header: zod_1.z.string().optional(),
    'header-footer-style': zod_1.z.string().optional(),
    images: zod_1.z.string().optional(),
    style: zod_1.z.string().optional()
})
    .passthrough();
exports.PMCFacetsSchema = zod_1.z
    .object({
    collapse: zod_1.z.boolean().optional(),
    conversions: zod_1.z.record(zod_1.z.string()).optional(),
    field: zod_1.z.string(),
    ignore: zod_1.z.array(zod_1.z.string().nullable()).optional(),
    input_type: zod_1.z.string().optional(),
    max_visible: zod_1.z.number().optional(),
    name: zod_1.z.string(),
    order_by: zod_1.z.string().optional(),
    order_by_custom: zod_1.z.array(zod_1.z.string()).optional(),
    show_count: zod_1.z.boolean().optional(),
    titlecase: zod_1.z.boolean().optional()
})
    .passthrough();
exports.PMCLogoMapEntrySchema = zod_1.z
    .object({
    img_url: zod_1.z.string(),
    value: zod_1.z.string()
})
    .passthrough();
exports.PMCModalDisplaySchema = zod_1.z
    .object({
    book_online_url: zod_1.z.boolean().optional(),
    hide_cta: zod_1.z.boolean().optional(),
    phone: zod_1.z.boolean().optional(),
    request_form_url: zod_1.z.boolean().optional(),
    skip_modal: zod_1.z.boolean().optional(),
    virtual_care: zod_1.z.boolean().optional()
})
    .passthrough();
exports.PMCProviderConfigSchema = zod_1.z
    .object({
    badge_data: zod_1.z.array(exports.PMCBadgeSchema).optional(),
    experience_data: zod_1.z.array(zod_1.z.unknown()).optional(),
    experience_data_fields: zod_1.z
        .record(zod_1.z.unknown())
        .or(zod_1.z.array(zod_1.z.record(zod_1.z.unknown())))
        .optional(),
    reviews: zod_1.z
        .object({
        disclaimer_text: zod_1.z.string().optional()
    })
        .passthrough()
        .optional(),
    summary_data: zod_1.z.array(zod_1.z.unknown()).optional(),
    tabs: zod_1.z.array(zod_1.z.unknown()).optional()
})
    .passthrough();
exports.PMCV8SearchWidgetValidTypeaheadCategoriesTypeSchema = zod_1.z.enum(types_1.PMCV8SearchWidgetValidTypeaheadCategories);
exports.PMCV8SearchWidgetValidTypeaheadCategoriesSchema = zod_1.z.union([
    zod_1.z.literal('name'),
    zod_1.z.literal('provider_name'),
    zod_1.z.literal('specialty'),
    zod_1.z.literal('specialty_strict'),
    zod_1.z.literal('specialty_synonym'),
    zod_1.z.literal('clinical_combined'),
    zod_1.z.literal('clinical_experience'),
    zod_1.z.literal('practice_group'),
    zod_1.z.literal('practice_location'),
    zod_1.z.literal('network_affiliation'),
    zod_1.z.literal('primary_care'),
    zod_1.z.literal('primary_care_condition')
]);
exports.PMCV8SearchWidgetValidTemplateNamesTypeSchema = zod_1.z.enum(types_1.PMCV8SearchWidgetValidTemplateNames);
exports.PMCV8SearchWidgetValidTemplateNamesSchema = zod_1.z.union([
    zod_1.z.literal('defaultPMC'),
    zod_1.z.literal('broadwayHealthDemo'),
    zod_1.z.literal('baptist')
]);
exports.summaryFieldSchema = zod_1.z
    .object({
    field: zod_1.z.string(),
    secondary_subarray: zod_1.z.string().optional(),
    secondary_subfield: zod_1.z.string().optional(),
    subfield: zod_1.z.string().optional()
})
    .passthrough();
exports.MlocPeriodsSchema = zod_1.z
    .object({
    closeDay: zod_1.z.string().optional().nullable(),
    closeTime: zod_1.z.string().optional().nullable(),
    openDay: zod_1.z.string().optional().nullable(),
    openTime: zod_1.z.string().optional().nullable()
})
    .passthrough();
exports.MlocSchema = zod_1.z.object({
    hours_of_operation: zod_1.z
        .object({
        notes: zod_1.z.string().nullable(),
        periods: zod_1.z.array(exports.MlocPeriodsSchema)
    })
        .passthrough()
        .nullable()
});
exports.PMCSlotStatusesSchema = zod_1.z.nativeEnum(types_1.PMCSlotStatuses);
exports.PMCLogoSectionsSchema = zod_1.z.nativeEnum(types_1.PMCLogoSections);
exports.PMCLogoSchema = exports.summaryFieldSchema.extend({
    logo_map: zod_1.z.array(exports.PMCLogoMapEntrySchema),
    show_in_profile: zod_1.z.boolean().optional(),
    show_in_search_results: zod_1.z.boolean().optional()
});
exports.PMCV8SearchWidgetTypeaheadCategorySchema = zod_1.z
    .object({
    category: exports.PMCV8SearchWidgetValidTypeaheadCategoriesSchema,
    display_as: zod_1.z.string().optional()
})
    .passthrough();
exports.PMCSummaryDataFieldsSchema = exports.summaryFieldSchema.extend({
    display_as: zod_1.z.string().optional()
});
exports.PMCV8SearchWidgetConfigSchema = zod_1.z
    .object({
    allow_empty_search: zod_1.z.boolean().optional(),
    environment: zod_1.z.string().optional(),
    external_link: zod_1.z
        .object({
        link: zod_1.z.string()
    })
        .passthrough()
        .optional(),
    focus_on_widget: zod_1.z.boolean().optional(),
    force_use_legacy_widget: zod_1.z.boolean().optional(),
    legal_message: zod_1.z.string().optional(),
    location_message: zod_1.z.string().optional(),
    location_search_radius: zod_1.z.number().optional(),
    message: zod_1.z.string().optional(),
    open_results_in_new_tab: zod_1.z.boolean().optional(),
    persist_params: zod_1.z.record(zod_1.z.string()).optional(),
    persist_query: zod_1.z.boolean().optional(),
    pre_filters: zod_1.z.array(zod_1.z.string()).optional(),
    search_label: zod_1.z.string().optional(),
    selectable_filters: zod_1.z.array(zod_1.z.record(zod_1.z.unknown())).optional(),
    show_location: zod_1.z.boolean().optional(),
    show_powered_by: zod_1.z.boolean().optional(),
    sort_order: zod_1.z.string(),
    template_name: exports.PMCV8SearchWidgetValidTemplateNamesSchema.optional(),
    typeahead_categories: zod_1.z.array(exports.PMCV8SearchWidgetTypeaheadCategorySchema),
    use_primary_care_condition: zod_1.z.boolean().optional()
})
    .passthrough();
const PMCActiveModulesSchema = zod_1.z
    .record(zod_1.z.enum((0, extract_1.extractValuesAsTuple)(types_1.PMCActiveModules)), zod_1.z
    .object({
    enabled: zod_1.z.boolean().optional().default(false)
})
    .passthrough()
    .default({ enabled: false }))
    .default(Object.entries(types_1.PMCActiveModules).reduce((accum, [_, value]) => {
    accum[value] = { enabled: false };
    return accum;
}, {}));
const fullTheme = Object.assign(Object.assign({}, ui_theme_1.default), ui_theme_1.FALLBACK_KEYS);
const ThemeSchema = zod_1.z
    .record(zod_1.z.enum((0, extract_1.extractKeysAsTuple)(fullTheme)), zod_1.z.string().or(zod_1.z.number()).optional().default(''))
    .default(fullTheme);
exports.PMCConfigSchema = zod_1.z.object({
    active_modules: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .or(PMCActiveModulesSchema.optional())
        .describe('The modules activated for this customer'),
    application_string_templates: zod_1.z
        .record(zod_1.z.string())
        .optional()
        .describe('The intl string translations for this customer'),
    crm: exports.crmConfigSchema
        .optional()
        .describe('Configurations for ProviderMatch CRM integration'),
    custom_versions: exports.PMCCustomVersionsSchema.optional().describe('The custom versions of assets to load from customer-static-assets'),
    customer_display_name: zod_1.z
        .string()
        .optional()
        .describe('The display name for the customer'),
    darkship_KENG_31725: zod_1.z
        .boolean()
        .optional()
        .describe('Enables pulling Search Widget V2 configs from the admin application'),
    display_availability_in_search: zod_1.z
        .boolean()
        .optional()
        .describe('Enables availability tiles on the search results page'),
    domain_whitelist: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .describe('List of domains the given customer can load from'),
    domains: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .describe('List of domains this customer is configured for'),
    emergency_disclaimer_md: zod_1.z
        .object({
        enabled: zod_1.z.boolean().optional(),
        markdown: zod_1.z.array(zod_1.z.string()).optional()
    })
        .passthrough()
        .optional()
        .describe('Markdown text for the emergency disclaimer'),
    facets: zod_1.z
        .array(exports.PMCFacetsSchema)
        .optional()
        .describe('List of facets to display for V8 search'),
    facets_v9: zod_1.z
        .array(exports.PMCFacetsSchema)
        .optional()
        .describe('List of facets to display for V9 search'),
    google_tag_manager_id: zod_1.z
        .string()
        .optional()
        .describe("The customer's Google Tag Manager ID"),
    gx_flows: zod_1.z
        .array(zod_1.z.unknown())
        .optional()
        .describe('List of question flows for Guided Experience V1'),
    gxv2_enabled: zod_1.z.boolean().optional().describe('Enables Guided Experience V2'),
    index: zod_1.z
        .string()
        .optional()
        .describe('The elastic search index to use for queries related to this customer'),
    insurance_disclaimer: zod_1.z
        .object({
        enabled: zod_1.z.boolean().optional(),
        message: zod_1.z.string().optional(),
        title: zod_1.z.string().optional()
    })
        .passthrough()
        .optional()
        .describe("The customer's insurance disclaimer"),
    location_facet: zod_1.z
        .object({
        miles: zod_1.z.string().optional(),
        options: zod_1.z.array(zod_1.z.string()).optional(),
        placeholder: zod_1.z.string().optional()
    })
        .passthrough()
        .optional()
        .describe('Configuration for controlling the location facet on the search results page'),
    logos: zod_1.z
        .array(exports.PMCLogoSchema)
        .optional()
        .describe('Customer logos for V8 search'),
    logos_v9: zod_1.z
        .array(exports.PMCLogoSchema)
        .optional()
        .describe('Customer logos for V9 search'),
    maps_config: zod_1.z
        .object({
        container_height: zod_1.z.string().optional().or(zod_1.z.number().optional()),
        google_routes: zod_1.z.boolean().optional(),
        location_service_provider: zod_1.z.enum(['aws', 'google']).optional()
    })
        .optional()
        .describe('Customer configuration for maps'),
    modal_display: exports.PMCModalDisplaySchema.optional().describe('CTA modal configuration for the customer'),
    primary_domain: zod_1.z
        .string()
        .optional()
        .describe("Main domain for the customer's instance of PMC"),
    provider: exports.PMCProviderConfigSchema.optional().describe('Customer provider config for V8 search'),
    provider_tile: exports.providerTileConfigSchema
        .optional()
        .describe('Customer provider tile/card config for search'),
    provider_v9: exports.PMCProviderConfigSchema.optional().describe('Customer provider config for V9 search'),
    request_form_url: zod_1.z
        .string()
        .optional()
        .describe('URL for the "Powered by Kyruus" demo request'),
    search_home: zod_1.z
        .string()
        .optional()
        .describe('URL indicating where the user will be navigated when starting a new search'),
    search_results_page: zod_1.z
        .object({
        summary_data: zod_1.z.array(exports.PMCSummaryDataFieldsSchema)
    })
        .passthrough()
        .optional()
        .describe('Configuration for the V8 search results page'),
    search_results_page_v9: zod_1.z
        .object({
        summary_data: zod_1.z.array(exports.PMCSummaryDataFieldsSchema)
    })
        .passthrough()
        .optional()
        .describe('Configuration for the V9 search results page'),
    search_results_logo_fields: zod_1.z.array(zod_1.z.string()).optional(),
    search_widget: exports.PMCV8SearchWidgetConfigSchema.optional().describe('Legacy configuration for Search Widget V1 and V2'),
    service_account_email: zod_1.z
        .string()
        .optional()
        .describe("Email address for the customer's service account"),
    show_availability_density: zod_1.z
        .boolean()
        .optional()
        .describe('Indicates whether to show availability density on the provider tile')
        .default(false),
    show_captcha: zod_1.z
        .boolean()
        .optional()
        .describe('Indicates whether to show the captcha for Direct Book'),
    show_powered_by_kyruus_logo: zod_1.z
        .boolean()
        .optional()
        .describe('Indicates whether to show the "Powered by Kyruus" logo'),
    site_title: zod_1.z
        .string()
        .optional()
        .describe('Title to display in the browser tab'),
    social_share: zod_1.z
        .record(zod_1.z.boolean())
        .optional()
        .describe('Configuration for which social media sharing to enable on the Provider Profile page'),
    sort_options: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .describe('List of options for sorting on the search results page'),
    source_system: zod_1.z
        .string()
        .optional()
        .describe('EHR source system for the customer'),
    style_sheet: zod_1.z
        .string()
        .optional()
        .describe("URL of the customer's CSS style sheet"),
    theme: ThemeSchema.optional().describe('Customer specific overrides for the site theme'),
    timezone: zod_1.z.string().optional().describe("Customer's timezone")
});
//# sourceMappingURL=validators.js.map